var React = require('react');

function Previous (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"previous"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("defs",{"key":2}),React.createElement("g",{"id":"Site","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":3},React.createElement("g",{"id":"previous","fill":"currentColor"},React.createElement("polygon",{"id":"›","transform":"translate(16.000000, 16.000000) scale(-1, 1) translate(-16.000000, -16.000000) ","points":"13 11 16.750105 16 13 21 14.1926978 22 19 16 14.1926978 10"})))]);
}

Previous.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Previous;

Previous.default = Previous;
